(function() { window.GUID_b028e0a5_2aad_4891_9b54_263cc65387e2 = { getGuid: function() { return "b028e0a5-2aad-4891-9b54-263cc65387e2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TextArea extends Controls.ControlValueBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            GetGalue() {
                return this.$textarea.val();
            }
            SetValue(value) {
                if (this.$textarea.is(':focus')) {
                    return;
                }
                this.$textarea.val(value);
            }
            OnControlInstantiation(params) {
                let me = this;
                me.controlId = params[0];
                me.$control = $('#' + params[0]);
                if (this.$Control.is('textarea')) {
                    this.$textarea = this.$Control;
                }
                else {
                    this.$textarea = this.$Control.find("textarea");
                }
                me.$textarea.css({
                    "resize": params[1]
                });
            }
            OnBindEvents() {
                let me = this;
                this.$Control.offon('keyup.' + this.UniqueNamespace + ' change.' + this.UniqueNamespace, function (e) {
                    if (e.keyCode == 9 || (e.keyCode > 36 && e.keyCode < 41)) {
                        return;
                    }
                    me.RaiseChange(e);
                });
            }
            OnDispose() {
                this.$Control.off('keyup.' + this.UniqueNamespace + ' change.' + this.UniqueNamespace);
                this.$Control.remove();
            }
        }
        Controls.TextArea = TextArea;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=textarea.js.map
